var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-info-box"},[_c('VPopover',{attrs:{"trigger":"hover","placement":"top"}},[_c('img',{attrs:{"src":"/icons/info-circle.svg","alt":"info"}}),_c('template',{slot:"popover"},[(_vm.title)?_c('header',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('main',[_vm._t("default")],2)])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }